import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';
import { FeatureFlag } from '@models';

@NgModule()
export class MLMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: MLMetaModule,
            providers: [
                providePageMeta({
                    title: 'ML Logs',
                    translationKey: 'page_mllogs',
                    routerLink: '/ml/logs',
                    icon: 'archive',
                    permission: 'MLLogs.View',
                    featureFlag: FeatureFlag.AIFabric,
                    type: 'SubMenu',
                    parentRoute: '/ml/skills',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'ML Skills',
                    translationKey: 'page_mlskills',
                    routerLink: '/ml',
                    permission: 'MLSkills.View',
                    featureFlag: FeatureFlag.AIFabric,
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                }),
                providePageMeta({
                    title: 'ML Skills',
                    translationKey: 'page_mlskills',
                    routerLink: '/ml/skills',
                    svgIcon: 'uipath:mlskills',
                    permission: 'MLSkills.View',
                    featureFlag: FeatureFlag.AIFabric,
                    type: 'Sidebar',
                    sidebarSection: 'Management',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 6,
                }),
                providePageMeta({
                    title: 'ML Packages',
                    translationKey: 'page_mlpackages',
                    routerLink: '/ml/packages',
                    icon: 'archive',
                    permission: 'MLPackages.View',
                    featureFlag: FeatureFlag.AIFabric,
                    type: 'SubMenu',
                    parentRoute: '/ml/skills',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
